import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages_ca from './lang/ca.js'
import messages_es from './lang/es.js'
import LayersSection from './components/LayersSection/Index'
import MapsSection from './components/MapsSection/Index'
import OgcCatalogSection from './components/OgcCatalogSection';
import SuggestionsSection from './components/SuggestionsSection';
import '../../vendor/cookiecuttr/cookiecuttr.js'


Vue.use(VueI18n);

const messages = {
    'es': messages_es,
    'ca': messages_ca,
};

const htmlLocale = document.getElementsByTagName('html')[0].getAttribute('lang');

const i18n = new VueI18n({
    locale: htmlLocale,
    messages,
});

// window.$ = window.jQuery = require('jquery');
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

new Vue({
    el: "#app",
    i18n,
    components: {
        LayersSection,
        MapsSection,
        OgcCatalogSection,
        SuggestionsSection
    }
});

setTimeout(() => {
    const sectionHash = window.location.hash.split('#')[1];

    if (sectionHash !== undefined) {
        const scrollIndex = window.document.getElementById(sectionHash).getAttribute('data-scroll-index');
        const navItemElement = window.document.querySelector(`[data-scroll-nav='${scrollIndex}']`);
        navItemElement.click();
    }
}, 1000);
